module.exports = __webpack_public_path__ + "img/facebook.ea0c122c.png";